var map = {
	"./Anyswap.png": 835,
	"./Anyswap.svg": 836,
	"./Artwork.svg": 837,
	"./Banxa.png": 838,
	"./DROP_DOWN.svg": 365,
	"./Hop.png": 839,
	"./Hop.svg": 840,
	"./Hop_dark.png": 841,
	"./Hop_dark.svg": 842,
	"./Synapse.png": 843,
	"./Synapse.svg": 844,
	"./arrow-left.svg": 845,
	"./background_mesh.png": 846,
	"./background_mesh_mobile.png": 509,
	"./binance.png": 847,
	"./bscscan.png": 848,
	"./btn_big_arbitrum.png": 849,
	"./btn_big_avalanche.png": 850,
	"./btn_big_bsc.png": 851,
	"./buy_transfer_eth.svg": 852,
	"./chevron-down.svg": 238,
	"./close-rounded.png": 378,
	"./close.svg": 853,
	"./coinbaseWallet.png": 510,
	"./coingecko.png": 854,
	"./copy.svg": 237,
	"./cross.svg": 855,
	"./discord.svg": 856,
	"./event-modal-header-mesh.png": 379,
	"./event-modal-header.png": 380,
	"./external-link.svg": 857,
	"./gitbook.svg": 858,
	"./github.svg": 859,
	"./graphite-01.png": 860,
	"./ic-communityproject.svg": 861,
	"./ic_arbitrum_16.svg": 362,
	"./ic_arbitrum_24.svg": 479,
	"./ic_arbitrum_96.svg": 862,
	"./ic_arbitrum_hover_16.svg": 863,
	"./ic_avalanche_16.svg": 864,
	"./ic_avalanche_24.svg": 480,
	"./ic_avalanche_96.svg": 865,
	"./ic_bal_24.svg": 481,
	"./ic_bal_40.svg": 458,
	"./ic_banxa.svg": 866,
	"./ic_binance_logo.svg": 867,
	"./ic_bsc.svg": 868,
	"./ic_bsc_96.svg": 869,
	"./ic_btc_24.svg": 482,
	"./ic_btc_40.svg": 459,
	"./ic_busd_24.svg": 483,
	"./ic_cash.png": 870,
	"./ic_cash.svg": 871,
	"./ic_coingecko_16.svg": 361,
	"./ic_coingecko_hover_16.svg": 872,
	"./ic_convert_down.svg": 369,
	"./ic_copy_16.svg": 375,
	"./ic_cost.svg": 873,
	"./ic_crv_24.svg": 484,
	"./ic_crv_40.svg": 460,
	"./ic_dai_24.svg": 485,
	"./ic_dai_40.svg": 461,
	"./ic_degen.svg": 370,
	"./ic_discord.svg": 874,
	"./ic_eth_24.svg": 486,
	"./ic_eth_40.svg": 351,
	"./ic_frax_24.svg": 487,
	"./ic_frax_40.svg": 462,
	"./ic_fxs_24.svg": 488,
	"./ic_fxs_40.svg": 463,
	"./ic_github.svg": 875,
	"./ic_gmx_arbitrum.svg": 876,
	"./ic_hop.svg": 877,
	"./ic_info.svg": 878,
	"./ic_kcc_16.svg": 360,
	"./ic_kcc_24.svg": 235,
	"./ic_kcc_96.svg": 879,
	"./ic_kcc_hover_16.svg": 880,
	"./ic_kcs_24.svg": 489,
	"./ic_kcs_40.svg": 464,
	"./ic_klp_24.svg": 236,
	"./ic_klp_40.svg": 156,
	"./ic_klp_custom.svg": 881,
	"./ic_kmx.svg": 882,
	"./ic_kmx_40.svg": 288,
	"./ic_kmx_custom.svg": 359,
	"./ic_link_24.svg": 490,
	"./ic_link_40.svg": 465,
	"./ic_liquidity.svg": 883,
	"./ic_medium.svg": 884,
	"./ic_metamask_16.svg": 363,
	"./ic_metamask_hover_16.svg": 885,
	"./ic_mim_24.svg": 491,
	"./ic_mim_40.svg": 466,
	"./ic_multiswap.svg": 886,
	"./ic_nav_close.svg": 381,
	"./ic_new_link_16.svg": 374,
	"./ic_olympus.svg": 887,
	"./ic_olympus_arbitrum.svg": 888,
	"./ic_ppusd_24.svg": 492,
	"./ic_ppusd_40.svg": 467,
	"./ic_selector_dropdowns.svg": 255,
	"./ic_settings_16.svg": 376,
	"./ic_sign in_16.svg": 889,
	"./ic_sign_out_16.svg": 377,
	"./ic_simpleswaps.svg": 890,
	"./ic_stats.svg": 891,
	"./ic_stats_big.svg": 892,
	"./ic_synapse.svg": 893,
	"./ic_tcr_24.svg": 493,
	"./ic_tcr_40.svg": 468,
	"./ic_telegram.svg": 894,
	"./ic_test_40.svg": 469,
	"./ic_tether_24.svg": 494,
	"./ic_tokens.svg": 895,
	"./ic_totaluser.svg": 896,
	"./ic_trading.svg": 897,
	"./ic_twitter.svg": 898,
	"./ic_uni_24.svg": 495,
	"./ic_uni_40.svg": 470,
	"./ic_usdc.e_24.svg": 496,
	"./ic_usdc.e_40.svg": 471,
	"./ic_usdc_24.svg": 497,
	"./ic_usdc_40.svg": 472,
	"./ic_usdt_24.svg": 498,
	"./ic_usdt_40.svg": 473,
	"./ic_wallet_24.svg": 194,
	"./ic_weth_24.svg": 499,
	"./ic_weth_40.svg": 474,
	"./ic_wkcs_24.svg": 500,
	"./ic_wkcs_40.svg": 475,
	"./ic_xkcs_24.svg": 501,
	"./ic_xkcs_40.svg": 476,
	"./ic_xusdt_24.svg": 502,
	"./ic_xusdt_40.svg": 477,
	"./klp_icon.svg": 899,
	"./kmx_pools.svg": 900,
	"./kmx_pools_short.svg": 511,
	"./kmx_pools_switch.svg": 901,
	"./kmx_swaps.svg": 902,
	"./lg_arbitrum.svg": 903,
	"./live.svg": 289,
	"./logo_KUS.svg": 149,
	"./logo_KUS_small.svg": 309,
	"./logo_TRS.svg": 904,
	"./logo_TRS_small.svg": 905,
	"./long.svg": 366,
	"./menu-icons": 132,
	"./menu-icons/": 132,
	"./menu-icons/farm": 280,
	"./menu-icons/farm.tsx": 280,
	"./menu-icons/index": 132,
	"./menu-icons/index.tsx": 132,
	"./menu-icons/kmx": 281,
	"./menu-icons/kmx.tsx": 281,
	"./menu-icons/kus": 282,
	"./menu-icons/kus.tsx": 282,
	"./menu-icons/nft": 283,
	"./menu-icons/nft.tsx": 283,
	"./menu-icons/prediction": 284,
	"./menu-icons/prediction.tsx": 284,
	"./metamask-text.svg": 906,
	"./metamask.png": 512,
	"./nav/analytics.svg": 907,
	"./nav/buy.svg": 908,
	"./nav/chevron-down.svg": 909,
	"./nav/chevron-left.svg": 910,
	"./nav/dashboard.svg": 911,
	"./nav/discord.svg": 912,
	"./nav/docs.svg": 913,
	"./nav/earn.svg": 914,
	"./nav/event-graphic.png": 513,
	"./nav/github.svg": 915,
	"./nav/kmx-icon.svg": 916,
	"./nav/kmx-staking.svg": 917,
	"./nav/logos/pools.svg": 918,
	"./nav/logos/staking.svg": 919,
	"./nav/logos/token-migration.svg": 920,
	"./nav/medium.svg": 921,
	"./nav/pull-tab.svg": 922,
	"./nav/referrals.svg": 923,
	"./nav/rewards.svg": 924,
	"./nav/trade.svg": 925,
	"./nav/trading-leaderboard.svg": 926,
	"./nav/translate.svg": 927,
	"./nav/twitter.svg": 928,
	"./page-not-found.svg": 382,
	"./referrals-comp/20k.svg": 383,
	"./referrals-comp/first.svg": 308,
	"./referrals-comp/podium-background.png": 371,
	"./referrals-comp/second.svg": 372,
	"./referrals-comp/third.svg": 373,
	"./short.svg": 367,
	"./swap.svg": 368,
	"./trading.png": 929,
	"./twitter-icon.svg": 384,
	"./twitter.svg": 930,
	"./wallet-connect-text.svg": 931,
	"./walletconnect-circle-blue.svg": 514,
	"./wave-01.png": 932,
	"./wave-02.png": 933
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 279;